module.exports = __webpack_public_path__ + "img/Floor_Attributes.e26b1632.png";